import { useCallback } from 'react';

import { captureException } from '@didaskill/services/sentry/react';

import api from '../../services/http/api';
import routes from '../routes';

export const useLogout = () =>
  useCallback(() => {
    api
      .get(routes.LOGOUT.ROOT)
      .then(() => {
        window.location.href = routes.LOGIN.ROOT;
      })
      .catch((error) => {
        captureException(error);
      });
  }, []);
